import { render, staticRenderFns } from "./AdminSegmentSchemaForm.vue?vue&type=template&id=0e036f04&"
import script from "./AdminSegmentSchemaForm.vue?vue&type=script&lang=js&"
export * from "./AdminSegmentSchemaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports